import React, { FC } from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import styles from "./DeleteListItemModal.module.scss";

interface DeleteListItemModalProps {
  onClose: () => void;
  selectedRow?: any;
  onRemove?: (id: number) => void;
  isDeleting?: boolean;
}

const DeleteListItemModal: FC<DeleteListItemModalProps> = ({
  onClose,
  selectedRow,
  onRemove,
  isDeleting,
}) => {
  const handleRemove = () => {
    if (selectedRow) {
      onRemove?.(selectedRow.id);
    }
    onClose();
  };

  return (
    <div className="create-promotion-modal">
      <Backdrop open={true}>
        <div className={styles["modalContainer"]}>
          <h4 className={styles["modalContainer__title"]}>Remove?</h4>

          <div className={styles["modalContainer__inputWrapper"]}>
            Are you sure you want to remove this row?
          </div>

          <div className={styles["modalContainer__buttonGroup"]}>
            <Button
              onClick={onClose}
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isDeleting}
            >
              Cancel
            </Button>

            <Button
              onClick={handleRemove}
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isDeleting}
              loading={isDeleting}
            >
              {isDeleting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Remove"
              )}
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>
  );
};

export default DeleteListItemModal;
